import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SiteEffects } from './state/site.effects';
import { siteFeatureKey, siteReducer } from './state/site.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(siteFeatureKey, siteReducer),
    EffectsModule.forFeature([SiteEffects])
  ]
})
export class SiteModule { }
